module.exports = __webpack_public_path__ + "img/wrapbg3.4bb109be.png";